import React from 'react';
import PropTypes from 'prop-types';
import NicknameFieldStore from '../../state-management/contexts/regform-fields/nickname-field-context';
import PasswordFieldStore from '../../state-management/contexts/regform-fields/password-field-context';
import EmailFieldStore from '../../state-management/contexts/regform-fields/email-field-context';
import TermsCheckboxStore from '../../state-management/contexts/regform-checkboxes/terms-checkbox-context';

function FieldStoresWrapper ({ children, termsOption = true }) {
	return (
		<NicknameFieldStore>
			<PasswordFieldStore>
				<EmailFieldStore>
					{termsOption ? (
						<TermsCheckboxStore>
							{children}
						</TermsCheckboxStore>
					) : (
						{ children }
					)}
				</EmailFieldStore>
			</PasswordFieldStore>
		</NicknameFieldStore>
	);
}

export default FieldStoresWrapper;

FieldStoresWrapper.propTypes = {
	children: PropTypes.element.isRequired,
	termsOption: PropTypes.bool,
};